/** EMBER & PALM — brighter lunch rhythm, verified offers only, with genuine fresh-food photography. */
import { ArrowRight, Clock3, Phone } from "lucide-react";
import { Link } from "wouter";
import { PageMeta } from "@/components/PageMeta";
import { lunchMenu, SITE, trackEvent } from "@/lib/site";

const deals = [
  ["Quick Lunch Deal", "1 rice bowl + 1 soft drink", "$26"],
  ["Lunch for Two", "2 rice bowls + 2 drinks + spring rolls to share", "$55"],
  ["Office Group Lunch", "4 rice bowls + 4 drinks + 2 starters", "$99"],
];

export default function LunchPage() {
  return (
    <>
      <PageMeta
        title="Lunch Specials | ANGKOR Cambodian Flavours"
        description="Cambodian lunch in West Melbourne, Tuesday–Friday from 11:30am. Fresh bowls, fragrant kroeung and good-value curries near Southern Cross Station."
        path="/lunch"
        image={SITE.images.seafood}
      />
      <section className="page-hero lunch-hero">
        <img src={SITE.images.seafood} alt="Cambodian seafood and rice lunch at ANGKOR in West Melbourne" width="1200" height="900" />
        <div className="page-hero-overlay" />
        <div className="container page-hero-copy">
          <p className="eyebrow">Tuesday–Friday · From 11:30am</p>
          <h1>Cambodian Lunch, <em>Made Fresh.</em></h1>
          <p>Bright bowls, fragrant kroeung and comforting curries for a lunch break that feels different.</p>
          <a className="button button-gold" href={SITE.booking} onClick={() => trackEvent("book_table_click", { placement: "lunch_hero" })}>Book a Lunch Table</a>
        </div>
      </section>

      <section className="section parchment-section">
        <div className="container lunch-layout">
          <div className="section-heading split-heading">
            <div><p className="eyebrow dark">01 — Lunch Bowls</p><h2>Fast enough for lunch. <em>Made without shortcuts.</em></h2></div>
            <p>All lunch bowls are made fresh to order. Allow 10–15 minutes; call ahead for groups of four or more.</p>
          </div>
          <div className="lunch-list">
            {lunchMenu.map((item, index) => (
              <article key={item.name}><span>0{index + 1}</span><div><h3>{item.name}</h3><p>{item.description}</p></div><strong>{item.price}</strong></article>
            ))}
          </div>
        </div>
      </section>

      <section className="section lunch-deals-section">
        <div className="container">
          <div className="section-heading split-heading"><div><p className="eyebrow">02 — Lunch Deals</p><h2>Good value, <em>properly cooked.</em></h2></div><p>Offers and prices can change. Please confirm the current selection with our team when booking.</p></div>
          <div className="deal-grid">
            {deals.map(([name, includes, price]) => <article key={name}><p>{name}</p><strong>{price}</strong><span>{includes}</span></article>)}
          </div>
          <div className="inline-actions"><a className="button button-gold" href={SITE.booking}>Book Lunch</a><a className="text-link light" href={`tel:${SITE.phone}`} onClick={() => trackEvent("phone_click", { placement: "lunch_deals" })}><Phone size={16} /> Pre-order: {SITE.phoneDisplay}</a></div>
        </div>
      </section>

      <section className="section lunch-drinks">
        <div className="container lunch-drink-grid">
          <img src={SITE.images.icedCoffee} alt="Cambodian iced coffee at ANGKOR Cambodian Flavours" width="1000" height="1200" loading="lazy" />
          <div><p className="eyebrow dark">03 — A Phnom Penh Pause</p><h2>Strong coffee. <em>Slow moment.</em></h2><p>Cambodian Iced Coffee combines strong drip coffee and condensed milk over ice. Also available: house-made lemongrass iced tea, coconut water, soft drinks and Angkor Beer.</p><div className="hours-pill"><Clock3 /> Tuesday to Friday from 11:30am · Lunch until 3pm Tue–Thu; Friday open straight through to 9:30pm.</div><Link href="/menu" className="text-link">View dinner menu <ArrowRight size={16} /></Link></div>
        </div>
      </section>
    </>
  );
}
